export enum CorePermission {
  login = "login",
  order = "order",
  academy = "academy",
  subscriptionsView = "subscriptionsView",
  subscriptionsCreate = "subscriptionsCreate",
  subscriptionsEdit = "subscriptionsEdit",
  externalLicenses = "externalLicenses",
  returns = "returns",
  brandstore = "brandstore",
  partnerProgram = "partnerProgram",
  partnerProgramConsumer = "partnerProgramConsumer",
  partnerProgramRestrictedData = "partnerProgramRestrictedData",
  partnerProgramCreateOpportunity = "partnerProgramCreateOpportunity",
  viewUserManagement = "viewUserManagement",
  partnerInfoManagement = "partnerInfoManagement",
  userManagement = "userManagement",
  distributorUserManagement = "distributorUserManagement",
  viewFinancialData = "viewFinancialData",
  trainingDataAdmin = "trainingDataAdmin",
}
